import { contractsUtils } from 'api/services/contracts';
import { Avatar, Button } from 'components';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import { formatDateWithMonthYear } from 'utils';
import './ContractCard.scss';

const ContractCard = ({ contract, onViewDetails }) => {
  const navigate = useNavigate();

  const handleSubmitProposal = (e) => {
    e.stopPropagation();
    navigate(`${contract.public_id}/submit-proposal`);
  };

  //TODO :-  Hardcoded stats for demo if missing
  const views = contract.views ?? 0;
  const bids = contract.bids ?? 0;

  return (
    <div className='contract-card-dashboard'>
      <div className='details-column'>
        <div className='contract-header'>
          <div className='contract-title'>{contract.title}</div>
        </div>

        <div className='contract-company'>
          <Avatar
            name={contract.business_name}
            size='sm'
            className='company-avatar'
          />
          <div className='company-info'>
            <div className='company-name'>{contract.business_name}</div>
          </div>
        </div>

        <div className='meta-row'>
          <span className='meta-amount'>
            $
            {contractsUtils
              .formatCurrency(contract.amount_usd)
              .replace('$', '')}
          </span>
          <span className='meta-item'>{contract.payment_type}</span>
          {contract.expected_duration_days && (
            <span className='meta-item'>
              {contract.expected_duration_days} days
            </span>
          )}
          <span className='meta-item'>{contract.expertise_level}</span>
        </div>

        <div className='footer-row'>
          <div className='stats-wrapper'>
            {views ? (
              <div className='stat-item'>
                <strong>{views}</strong> views
              </div>
            ) : null}
            {bids ? (
              <div className='stat-item'>
                <strong>{bids}</strong> bids
              </div>
            ) : null}
          </div>
        </div>

        {/* Skills/Tech Stack Section */}
        {contract.tech_stack && contract.tech_stack.length > 0 && (
          <div className='skills-row'>
            <div className='skills-label'>Skills:</div>
            <div className='skills-list'>
              {contract.tech_stack.slice(0, 5).map((skill, index) => (
                <span key={index} className='skill-badge'>
                  {skill}
                </span>
              ))}
              {contract.tech_stack.length > 5 && (
                <span className='skill-more'>
                  +{contract.tech_stack.length - 5} more
                </span>
              )}
            </div>
          </div>
        )}
      </div>

      <div className='actions-column'>
        <div className='contract-date'>
          {formatDateWithMonthYear(contract.created_at)}
        </div>

        <Button
          variant='outline'
          className='btn-details'
          onClick={(e) => {
            e.stopPropagation();
            onViewDetails(contract.public_id);
          }}
        >
          Details
        </Button>
        <Button onClick={handleSubmitProposal} variant='primary-purple'>
          Proposal
        </Button>
      </div>
    </div>
  );
};

ContractCard.propTypes = {
  contract: PropTypes.object.isRequired,
  onViewDetails: PropTypes.func.isRequired,
};

export default ContractCard;
